import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
interface OneSystemSlideProps {
  content: {
    headline: string;
    features: string[];
  };
}
export function OneSystemSlide({
  content
}: OneSystemSlideProps) {
  return <div className="bg-[#017C6D] rounded-2xl p-16 min-h-[600px] flex flex-col justify-center relative overflow-hidden" data-id="element-194">
      {/* Decorative background element */}
      <div className="absolute -right-20 -top-20 w-96 h-96 bg-[#0FB07D] rounded-full opacity-20 blur-3xl" data-id="element-195" />
      <div className="absolute -left-20 -bottom-20 w-96 h-96 bg-[#1C1C1C] rounded-full opacity-20 blur-3xl" data-id="element-196" />

      <motion.h2 initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="text-5xl font-bold text-white mb-16 text-center relative z-10" data-id="element-197">
        {content.headline}
      </motion.h2>

      <div className="max-w-4xl mx-auto w-full space-y-6 relative z-10" data-id="element-198">
        {content.features.map((feature, index) => {
        const [boldPart, ...rest] = feature.split(' (');
        const description = rest.length > 0 ? `(${rest.join(' (')}` : '';
        return <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.2 + index * 0.1
        }} className="flex items-center gap-6 bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/20 hover:bg-white/20 transition-colors" data-id="element-199">
              <CheckCircle2 className="text-[#0FB07D] w-8 h-8 flex-shrink-0" data-id="element-200" />
              <p className="text-2xl text-white" data-id="element-201">
                <strong className="font-bold" data-id="element-202">{boldPart}</strong>
                {description && <span className="text-white/80 font-normal ml-2" data-id="element-203">
                    {description}
                  </span>}
              </p>
            </motion.div>;
      })}
      </div>
    </div>;
}
export default OneSystemSlide;